import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';

class EditTransfer extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			admissionno : '',
			name : '',
			father : '',
			community : '',
			caste : '',
			admissiondate : '',
			course : '',
			part3 : '',
			medium : '',
			part1 : '',
			promo : '',
			ac : '',
			identify1 : '',
			identify2 : '',
			studcharacter : '',
			msheetno : '',
			tmrcode : '',
			scholar : '',
			medical : '',
			study  : '',
			nationality : '',
			religion : '',
			gender : '',
			dob : '',
			leftdate : '',
			applicationdate : '',
			issuedate : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			_redirectView : false,
			posts : [],
			caste : [],
			communi : [],
			reli : [],
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onView = this.onView.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	onView(e){
		
		this.setState({_redirectView : true});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	onSubmit(e){
		e.preventDefault();
			$("#showLoader").show();
		PostData('certificate/edittransfer',this.state).then((result) => {
				$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Certificate Updated Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("typeform").reset();
				this.getdata();
			}
			else{
		
				this.setState({
					_message:'Already Added',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	componentWillMount() {
		 
		this.getdata();
	}
	
	getdata(){
			$("#showLoader").show();
		GetData('certificate/gettransferbyregno/'+this.props.match.params.id).then((result) => {
				$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					ac : res[0]['academicyear'],
					name : res[0]['studentname'],
					admissionno : res[0]['admissionno'],
					father : res[0]['fathername'],
					community : res[0]['community'],
					cast : res[0]['caste'],
					admissiondate : res[0]['admissiondate'],
					religion : res[0]['religion'],
					nationality : res[0]['nationality'],
					gender : res[0]['gender'],
					dob : res[0]['dob'],
					clas : res[0]['admissionclass'],
					identify1 : res[0]['identify1'],
					identify2 : res[0]['identify2'],
					studcharacter : res[0]['studcharacter'],
					study : res[0]['study'],
					leaveclass : res[0]['leaveclass'],
					course : res[0]['course'],
					part1 : res[0]['part1'],
					part3 : res[0]['part3'],
					medium : res[0]['medium'],
					promo : res[0]['promo'],
					scholar : res[0]['scholarship'],
					medical : res[0]['medical'],
					msheetno : res[0]['marksheetno'],
					register : res[0]['register'],
					tmrcode : res[0]['tmrcode'],
					applicationdate : res[0]['applicationdate'],
					leftdate : res[0]['leftdate'],
					issuedate : res[0]['issuedate']
				});
			}
		});
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/academic/certificate/transfer'} />);

	}	
	if(this.state._redirectView){
		
		return (<Redirect to={'/academic/certificate/viewtransfer/'+ this.state.id} />);
	}
	
	this.state.id = this.props.match.params.id;
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			   <form action="" method="post" role="form" id="transform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Edit Transfer Certificate</strong>
							<Button outline color="primary" className="btn-right" onClick={this.onView}>View</Button>
							<Button outline color="primary" className="btn-right" onClick={this.onBack}>Back</Button>
						</CardHeader>
						<CardBody>
						  <Row>
							<Col md="6">
							<Row>
							  <Col md="6">
							   <FormGroup>
								<Label>Admission No </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="admissionno" value={this.state.admissionno} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Student Name </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="name" value={this.state.name} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Father or Mother Name </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="father" value={this.state.father} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Community </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="community" value={this.state.community} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Caste </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="cast" value={this.state.cast} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Admission Date </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="date" name="admissiondate" value={this.state.admissiondate} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							   <Col md="6">
							   <FormGroup>
								<Label>The Course offered i.e General/Vocation Education </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="course" value={this.state.course} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Whether qualified for promotion to higher standard </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="promo" value={this.state.promo} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							   <Col md="6">
							   <FormGroup>
								<Label>Subjects offered under Part-III </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="part3" value={this.state.part3} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Part-I </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="part1" value={this.state.part1} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Medium</Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="medium" value={this.state.medium} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							</Row>
							</Col>
							<Col md="6">
							<Row>
							  <Col md="6">
							   <FormGroup>
								<Label>Nationality </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="nationality" value={this.state.nationality} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Religion </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="religion" value={this.state.religion} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Gender </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="gender" value={this.state.gender} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>DOB </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="date" name="dob" value={this.state.dob} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Date of Left the School </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="date" name="leftdate" value={this.state.leftdate} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Conduct and Character </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="studcharacter" value={this.state.studcharacter} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Date of Application TC </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="date" name="applicationdate" value={this.state.applicationdate} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Date of Issue TC </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="date" name="issuedate" value={this.state.issuedate} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Scholarship </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="scholar" value={this.state.scholar} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Medical Inspection </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="medical" value={this.state.medical} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Course of Study (Academic Year) </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="ac" value={this.state.ac} onChange={this.onChange} disabled/>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Label>Course of Study (Standard(s) Studied) </Label>
							   </FormGroup>
							  </Col>
							  <Col md="6">
							   <FormGroup>
								<Input type="text" name="study" value={this.state.study} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							</Row>
							</Col>
							<Col md="12">
							<Row>
							  <Col md="3">
							   <FormGroup>
								<Label style={{float : 'right'}}>Personal Marks of Identification (1)</Label>
							   </FormGroup>
							  </Col>
							  <Col md="9">
							   <FormGroup>
								<Input type="text" name="identify1" value={this.state.identify1} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							  <Col md="3">
							   <FormGroup>
								<Label style={{float : 'right'}}>(2)</Label>
							   </FormGroup>
							  </Col>
							  <Col md="9">
							   <FormGroup>
								<Input type="text" name="identify2" value={this.state.identify2} onChange={this.onChange} />
							   </FormGroup>
							  </Col>
							</Row>
							</Col>
							<Col md="12">
							<Row>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Marksheet No </Label>
								  <Input type="text" name="msheetno" onChange={this.onChange} value={this.state.msheetno} />
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">Register No </Label>
								  <Input type="text" name="register" onChange={this.onChange} value={this.state.register}/>
								</FormGroup>
							  </Col>
							  <Col md="4">
								<FormGroup>
								  <Label htmlFor="name">TMR Code </Label>
								  <Input type="text" name="tmrcode" onChange={this.onChange} value={this.state.tmrcode} />
								</FormGroup>
							  </Col>
							</Row>
							</Col>
						  </Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" className="btn-right" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default EditTransfer;


// WEBPACK FOOTER //
// ./src/certificate/Transfer/EditTransfer.js